<template>
  <div class="contador-padrao-container">
    <div class="contador-padrao ">
      <div
        v-if="contadorCheio"
        class="contador-padrao-wrapper contador-padrao-wrapper-full"
        v-b-tooltip.hover.top
        :title="tituloTooltip"
      >
        <div class="contador-atual contador-atual-full contador-padrao-wrapper-full">
          {{ contadorAtual ? contadorAtual : "0" }}
          <div v-if="contadorAtual || contadorAtual == 0">
            {{ contadorAtual }}
          </div>
          <div v-else>
            <LoadingPadraoContainerMini delay="5000" />
          </div>
        </div>
        <div class="contador-total">{{ contadorTotal }}</div>
      </div>

      <div v-else class="contador-padrao-wrapper" v-b-tooltip.hover.top :title="tituloTooltip">
        <div class="contador-atual">
          {{ contadorAtual ? contadorAtual : "0" }}
          <div v-if="contadorAtual || contadorAtual == 0">
            {{ contadorAtual }}
          </div>
          <div v-else>
            <div class="counter-loading">
              <LoadingPadraoContainerMini delay="5000" />
            </div>
          </div>
        </div>
        <div class="contador-total">{{ contadorTotal }}</div>
      </div>
    </div>
    <h2 v-if="legenda" class="legenda-contador">
      {{ legenda }}
    </h2>
  </div>
</template>

<script>
import LoadingPadraoContainerMini from "@/components/LoadingPadrao/LoadingPadraoContainerMini.vue";

export default {
  name: "CounterNcm",
  components: {
    LoadingPadraoContainerMini
  },
  props: {
    contadorAtual: Number,
    contadorTotal: String | Number,
    tituloTooltipCheio: String,
    tituloTooltip: String,
    legenda: String
  },
  computed: {
    contadorCheio() {
      return this.contadorAtual >= this.contadorTotal;
    }
  }
};
</script>

<style lang="scss">
.contador-padrao-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  cursor: default;
  user-select: none;
  div {
    transition: all 0.8s ease-in-out;
    &::after {
      transition: all 0.8s ease-in-out;
    }
  }
}
.contador-padrao {
  margin: 4px 0 4px 7px;
  min-width: 50px;
}

.contador-padrao-wrapper {
  display: flex;
  background: var(--azul5);
  font-family: "Roboto Condensed";
  font-weight: bold;
  border-radius: 10px;
  font-size: 16px;
  // position: relative;
  height: 28px;
  width: fit-content;
  box-shadow: 2px 2px 4px var(--sombra2);
}
.contador-atual {
  position: relative;
  width: 100%;
  min-width: 30px;
  background-color: var(--azul5);
  color: transparent;
  line-height: 28px;
  width: fit-content;
  padding: 0 0px 0 10px;
  text-align: center;
  border-radius: 10px 0 0 10px;
  > div {
    min-width: 30px;
    position: absolute;
    width: 100%;
    bottom: 1px;
    left: -7px;
    background-color: var(--azul3);
    color: var(--branco);
    line-height: 28px;
    width: fit-content;
    padding: 0 0px 0 10px;
    text-align: center;
    margin-bottom: 2px;
    border-radius: 10px 0 0 10px;
    &::after {
      position: absolute;
      top: 0;
      right: -25px;
      content: "";
      height: 28px;
      width: 25px;
      border-bottom: 15px solid transparent;
      border-left: 13px solid var(--azul3);
      border-top: 13px solid var(--azul3);
      border-right: 12px solid transparent;
    }
  }
}

.contador-total {
  color: var(--cinza1);
  text-align: center;
  padding-left: 15px;
  padding-right: 10px;
  height: 100%;
  line-height: 28px;
  min-width: 40px;
}

.contador-padrao-wrapper-full {
  background: var(--vermelho4);
}
.contador-atual-full {
  > div {
    background-color: var(--vermelho3);
    &::after {
      border-left: 13px solid var(--vermelho3);
      border-top: 13px solid var(--vermelho3);
    }
  }
}
.legenda-contador {
  font-family: "Roboto Condensed";
  font-weight: normal;
  color: #8c98a1;
  font-size: 13px;
  float: left;
  width: 100%;
  text-transform: initial;
  // margin-top: 1px;
  margin-bottom: 0px;
}
.counter-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
}
</style>
